import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Receiving } from './receiving';
import { ReceivingItem } from './receiving-item';
import { Configuration } from '../../app.constants';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { Branch } from '../accounting/branch';

@Injectable()
export class ReceivingService {
    _receivingUrl = this._configuration.apiUrl + '/v2/receiving';
    _colorUrl = this._configuration.apiUrl + '/v2/color';

    constructor(private _http: Http,
        private _configuration: Configuration,
        public _authService: AuthenticationService) { }

    getReceivings(): Observable<Receiving[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('list', 'true');

        return this._http.get(this._receivingUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['receivingorders'] == null || !Array.isArray(body['receivingorders']))
                    return [];
                return body['receivingorders'];
            }
        );
    }

    getReceiving(recNumber: string): Observable<Receiving> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', recNumber);

        return this._http.get(this._receivingUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: Receiving;

                if (body['receivingorders'] == null || !Array.isArray(body['receivingorders'])) {
                    final = new Receiving();
                } else {
                    final = body['receivingorders'][0];
                }

                console.log(final);
                final.actual_arrival_date = final.actual_arrival_date ? final.actual_arrival_date.substring(0, 10) : '';
                final.estimated_arrival_date = final.estimated_arrival_date ? final.estimated_arrival_date.substring(0, 10) : '';
                final.order_date = final.order_date ? final.order_date.substring(0, 10) : '';

                return final;
            }
        );
    }

    getReceivingItemsByReceivingNumber(recNumber: string): Observable<ReceivingItem[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('receiving_number', recNumber);

        return this._http.get(this._receivingUrl + '/items', { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (Array.isArray(body)) {
                    return body;
                } else {
                    return [];
                }
            }
        );
    }

    getReceivingItems(order_id: string): Observable<ReceivingItem[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', order_id);

        return this._http.get(this._receivingUrl + '/items', { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (Array.isArray(body)) {


                    console.log("muiedinamo2");
                    console.log(body);

                    for (let i in body) {
                        body[i].design_color = body[i].mystic_design + "/" + body[i].mystic_color;
                    }

                    return body;
                } else {
                    return [];
                }
            }
        );
    }

    createReceivingItems(rec_id: string, items: ReceivingItem[], useSupplier?: boolean) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', rec_id);
        if (useSupplier) {
            s.append('use_supplier', useSupplier + '');
        }

        return this._http.post(this._receivingUrl + '/items', items, { headers: h, search: s }).map(response => response.json());
    }

    createReceiving(po_id: string, notes?: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        let recv = { po_id: po_id };
        if (notes) recv['notes'] = notes;

        return this._http.post(this._receivingUrl, recv, { headers: h, search: s }).map(response => response.json());
    }

    deleteReceiving(recv_id: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', recv_id);

        return this._http.delete(this._receivingUrl, { headers: h, search: s }).map(response => response.json());
    }

    deleteReceivingByPo(po_id: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('po_id', po_id);

        return this._http.delete(this._receivingUrl, { headers: h, search: s }).map(response => response.json());
    }

    updateReceiving(receiving: Receiving) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', receiving.id + '');

        return this._http.put(this._receivingUrl, receiving, { headers: h, search: s }).map(response => response.json());
    }

    setReceivedPieces(rec_id: string, receivedPieces: any[]) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', rec_id);

        return this._http.put(this._receivingUrl + '/items', { headers: h, search: s }).map(response => response.json());
    }

    checkProduct(collection, design, color, supplier_collection, supplier_design, supplier_color) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('check', 'true');
        if (collection != null) {
            s.append('collection_name', collection);
        }
        if (design != null) {
            s.append('design_name', design);
        }
        if (color != null) {
            s.append('name', color);
        }
        if (supplier_collection != null) {
            s.append('collection_supplier_name', supplier_collection);
        }
        if (supplier_design != null) {
            s.append('design_supplier_name', supplier_design);
        }
        if (supplier_color != null) {
            s.append('supplier_name', supplier_color);
        }

        return this._http.get(this._colorUrl, { headers: h, search: s }).map(
            response => {
                let body = Object.assign({ collection: supplier_collection, design: supplier_design, color: supplier_color }, response.json());
                return body;
            }
        );
    }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/receiving/receiving.service.ts